
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/books/no-rules-rules",
      function () {
        return require("private-next-pages/books/no-rules-rules.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/books/no-rules-rules"])
      });
    }
  